import { TagAllowedEntry } from '@/core/notifications/model';
import { normalizeAllowedEntry } from '@/core/notifications/model/tag-schema';
import { CheckboxRow } from '@/shared/components/export';

export default function FlatAllowedList({
  entries,
  selected,
  onToggleLeaf,
}: {
  entries: TagAllowedEntry[];
  selected: string[];
  onToggleLeaf: (leafKey: string) => void;
}) {
  const nodes = entries.map(normalizeAllowedEntry);

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        columnGap: 12,
        rowGap: 4,
      }}
    >
      {nodes.map(node => (
        <CheckboxRow
          key={node.key}
          checked={selected.includes(node.key)}
          onChange={() => onToggleLeaf(node.key)}
          // a plain string label gets truncated with an ellipsis (CheckboxRow's
          // default, right for tight single-line rows) — wrapping it in a node
          // instead lets a long name break onto a second line so nothing gets
          // cut off, no matter how narrow this column ends up being
          label={<span title={node.key}>{node.name ?? node.key}</span>}
        />
      ))}
    </div>
  );
}
